import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from '../ui/Container/Container';
import { Logo } from '../ui/Logo';

export function PublicFooter() {
  return (
    <footer className="py-8 border-t bg-white">
      <Container size="lg">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <Logo size="sm" />
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Turn your creative vision into scalable workflows with AI
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Product</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/pricing" className="text-muted-foreground hover:text-primary-600 transition-colors">Pricing</Link></li>
              <li><Link to="/" className="text-muted-foreground hover:text-primary-600 transition-colors">Features</Link></li>
              <li><Link to="/blog" className="text-muted-foreground hover:text-primary-600 transition-colors">Blog</Link></li>
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Support</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/help" className="text-muted-foreground hover:text-primary-600 transition-colors">Help Center</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-primary-600 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="text-muted-foreground hover:text-primary-600 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-muted-foreground hover:text-primary-600 transition-colors">Terms of Service</Link></li>
              <li><Link to="/refund-policy" className="text-muted-foreground hover:text-primary-600 transition-colors">Refund Policy</Link></li>
              <li><Link to="/cookie-policy" className="text-muted-foreground hover:text-primary-600 transition-colors">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-8 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-muted-foreground">
          <span>&copy; {new Date().getFullYear()} Cascady. All rights reserved.</span>
          <div className="flex gap-4 mt-4 md:mt-0">
            <Link to="/auth" className="hover:text-primary-600 transition-colors">Sign in</Link>
            <Link to="/auth?tab=register" className="hover:text-primary-600 transition-colors">Get started</Link>
          </div>
        </div>
      </Container>
    </footer>
  );
}
